import React, { useEffect, useState } from 'react';

import { ethers } from 'ethers';

import { useGlobalContext } from '../../AppContext';
import { add_favorite_token } from '../../utils/apiOperations';
import { Button } from '../Button';
import { ConfirmAlert } from '../ConfirmAlert';

import './AddFavoriteToken.scss';

interface AddFavoriteTokenProps {
  onClose?: any;
}
const theme = document.body.classList.contains("dark") ? "light" : "dark";

export const AddFavoriteToken = (props: AddFavoriteTokenProps) => {
  const { setFavorites, tokenDetails } = useGlobalContext();

  // use state
  const [newAddress, setNewAddress] = useState<string>('');
  const [validNewToken, setValidNewToken] = useState<boolean>(false);
  const [showAddNewTokenError, setShowAddNewTokenError] = useState<string>('');

  // wallets
  const handleOnChangeAddNewToken = (e: any) => {
    setNewAddress(e.target.value);

    if (e.target.value) {
      if (ethers.utils.isAddress(e.target.value)) {
        setValidNewToken(true);
      } else {
        setValidNewToken(false);
      }
    } else {
      setValidNewToken(false);
    }
  };

  // use effect
  useEffect(() => {
    setShowAddNewTokenError('');
  }, [newAddress]);

  return (
    <div className="add-favorite-token">
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className={`react-confirm-alert-${theme}`}>
            <ConfirmAlert title="Add New Token" onClose={props.onClose}>
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Enter wallet address..."
                  onChange={e => handleOnChangeAddNewToken(e)}
                />
              </div>
              {showAddNewTokenError && (
                <div className="alert">
                  <img src="/icons/warning-solid.svg" />
                  {showAddNewTokenError}
                </div>
              )}
              <div className="confirm-button-container">
                <Button color="six" size="large" label="Cancel" onClick={props.onClose} />
                <Button
                  color="one"
                  size="large"
                  disabled={!validNewToken}
                  onClick={() => {
                    if (tokenDetails[newAddress.toLowerCase()])
                      add_favorite_token(
                        tokenDetails[newAddress.toLowerCase()].coingeckoid,
                        setFavorites,
                      );
                  }}
                  label="Add to Favorites"
                />
              </div>
            </ConfirmAlert>
          </div>
        </div>
      </div>
    </div>
  );
};
